// extracted by mini-css-extract-plugin
export default {"wrapper":"InputLabel_wrapper__ybmj6","label":"InputLabel_label__qOXPa"};